import React, { useEffect, useState } from 'react';
import queryString from 'query-string';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { userActionCreators } from '../../../stores/lis-user-store';
import { cancelRequest } from '../../../services/request.service';
import { authActionCreators } from '../../../stores/lis-auth-store';
import { Link } from 'react-router-dom';

const ChangePassword = (props) => {
    const [isResettingPassword, toggleResettingPassword] = useState(false); // Why yes, we track 3 things with a bool
    const [passwordResetError, setPasswordResetError] = useState('');

    useEffect(() => {
        toggleResettingPassword(true);
        const resetHash = props.match.params.resethash;
        let emailAddress;
        if (props.location.search) {
            emailAddress = queryString.parse(props.location.search).emailaddress;
            if (emailAddress) { emailAddress = emailAddress.replaceAll(" ", "+") }
        }
        props.actions.resetPassword({ HashedWord: resetHash, EmailAddress: emailAddress })
            .then(() => {
                toggleResettingPassword(false);
            }).catch(err => {
                if (err === 'Aborted') {
                    return
                }
                setPasswordResetError(props.users?.passwordResetError?.Value ?? err.toString());
            })
    }, []);

    useEffect(() => {

    }, [isResettingPassword]);

    if (isResettingPassword) {
        if (passwordResetError !== '') {
            return <div className="center">
                <div className="fail">There was a problem resetting your password</div>
                <div>{passwordResetError.toLowerCase().includes('information could not be found in cache') ? <Link to="/forgot-password">Try again</Link> : passwordResetError}</div>
            </div>;
        }
        return (<div className="spinner center-spinner">Resetting Password</div>)
    } else if (isResettingPassword === false) {
        return <div className="dlas-forms change-password">
            <p>Your password has been reset. Check your email for your temporary password.</p>
            <Link to='/login'>Login here</Link>
        </div>
    } // But what about null!
    return <div></div>;
}

export default connect(
    (state) => {
        const { users, login } = state;
        return {
            users,
            login
        }
    },
    (dispatch) => {
        return {
            actions: bindActionCreators(Object.assign({}, userActionCreators, authActionCreators), dispatch)
        }
    }
)(ChangePassword);
